import React from 'react'
import { Link } from 'react-router-dom'
const Header = () => {
    return (
        <div>

            <header className="main-header" style={{ position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 1000, background: 'rgba(11, 15, 23, 0.9)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)', borderBottom: '1px solid rgba(255, 255, 255, 0.08)' }}>
                <div className="container container-1620">
                    <div className="d-flex align-items-center justify-content-between py-3">
                        <div className="logo d-flex align-items-center gap-2">
                            <Link to="/" style={{ fontSize: '22px', fontWeight: '800', color: '#F8FAFC', textDecoration: 'none', letterSpacing: '-0.5px' }}>
                                Manoj <span style={{ color: '#38BDF8' }}>Parmar</span>
                            </Link>
                            <span style={{ display: 'inline-block', width: '6px', height: '6px', borderRadius: '50%', background: '#38BDF8', boxShadow: '0 0 10px #38BDF8' }}></span>
                        </div>
                        <div>
                            <Link to="/" className="btn-executive-secondary py-2 px-4" style={{ fontSize: '13.5px' }}>
                                <i className="far fa-arrow-left me-2"></i> Back to Home
                            </Link>
                        </div>
                    </div>
                </div>
            </header>




























        </div>
    )
}

export default Header